import { fetchApi } from "./api";

export type NewsArticleInput = {
  title: string;
  slug: string;
  image_url?: string | null;
  header_image_url?: string | null;
  /** Alt text for the list/header image (migration 024). */
  image_alt?: string | null;
  excerpt?: string | null;
  body_html?: string | null;
  external_url?: string | null;
  category?: string | null;
  published_at: string;
  is_active?: boolean;
  has_newsletter?: boolean;
  /** null = auto-detect (legacy), 'email' = iframe, 'clean' = native render. */
  body_format?: "email" | "clean" | null;
};

// Public: list active news articles.
export const listNewsArticles = () =>
  fetchApi<any[]>("content", "listNewsArticles", {}, { auth: false });

// Public: slug of the active article imported from legacy CMS document
// `source_content_id` (the contentid of the old site), for the legacy-URL
// redirect layer. Null when nothing matches.
export const getNewsArticleByLegacyId = (opts: { data: { id: number } }) =>
  fetchApi<{ slug: string } | null>("content", "getNewsArticleByLegacyId", opts.data, {
    auth: false,
  });

// Admin: list all news articles including inactive ones. Metadata only — the
// bodies are far too large to return 200+ of them in one Data API result.
export const listAllNewsArticles = () => fetchApi<any[]>("content", "listAllNewsArticles");

// Admin: one article WITH its body_html, for the edit dialog.
export const getNewsArticleAdmin = (opts: { data: { id: string } }) =>
  fetchApi<any>("content", "getNewsArticleAdmin", opts.data);

export const createNewsArticle = (opts: { data: NewsArticleInput }) =>
  fetchApi<any>("content", "createNewsArticle", opts.data);

export const updateNewsArticle = (opts: { data: NewsArticleInput & { id: string } }) =>
  fetchApi<any>("content", "updateNewsArticle", opts.data);

export const deleteNewsArticle = (opts: { data: { id: string } }) =>
  fetchApi<{ ok: true }>("content", "deleteNewsArticle", opts.data);
